import snakeCase from "lodash/snakeCase";
import omit from "lodash/omit";
import merge from "lodash/merge";
import isEmpty from "lodash/isEmpty";
import omitBy from "lodash/omitBy";

import { transformObject } from "@stadium/helpers/formatter";

// Wrapper function that uses lodash isEmpty but doesn't treat numbers as empty
const isEmptyValue = (value) => {
  if (typeof value === "number" || typeof value === "boolean") return false;
  return isEmpty(value);
};

import {
  snackmagic,
  swagmagic,
  superiordishes,
  stadium,
  teambuilds,
} from "@stadium/constants/brands";
import {
  getCustomizeYourDemoOfferings,
  OTHER,
  QUERY_ORIGIN,
  RESTRICT_CHILIPIPER_KEYS,
} from "constants/book-a-call";
import { SM_PROGRAM_ID } from "constants/app-defaults";

export const getFormattedResponse = (formValues) => {
  const { firstName, lastName, email, companyName, ...rest } = formValues;
  const mapSnakifiedKeyValues = (obj) => transformObject(obj, snakeCase, (item) => item);
  const preferencesObj = { ...mapSnakifiedKeyValues(rest) };
  const responseObj = {
    ...mapSnakifiedKeyValues({
      firstName,
      lastName,
      email,
      company: companyName,
      origin: QUERY_ORIGIN,
      program_id: Number(SM_PROGRAM_ID),
    }),
  };

  const formattedResponse = {
    ...omitBy(responseObj, isEmptyValue),
    preferences: omitBy(preferencesObj, isEmptyValue),
  };
  return formattedResponse;
};

export const getFormattedOfferings = ({ offeringsValue, offeringsOtherValue }) => {
  const selectedOfferingsSet = new Set<string>(offeringsValue.map((v) => v.trim()));
  const result = {};

  const CUSTOMIZE_YOUR_DEMO_OFFERINGS = getCustomizeYourDemoOfferings();

  CUSTOMIZE_YOUR_DEMO_OFFERINGS.forEach(({ title, options }) => {
    const matchedTitles = options
      .map((option) => option.title)
      .filter((title) => selectedOfferingsSet.has(title));

    if (matchedTitles.length) {
      result[title] = `${title}: ${matchedTitles.join(", ")}`;
    }
  });

  if (offeringsOtherValue?.length) {
    result[OTHER] = `${OTHER}: ${offeringsOtherValue}`;
  }

  return result;
};

export const getFormattedResponseForAnalytics = (formValues) => {
  const updatedFormValues = omit(formValues, RESTRICT_CHILIPIPER_KEYS);
  const mergedFormValues = merge(updatedFormValues, updatedFormValues.preferences);

  delete mergedFormValues.preferences;

  return omitBy(mergedFormValues, isEmptyValue);
};

export const getFormattedResponseForAuthParams = (formValues) => {
  const { firstName, lastName, email, role, signupRequired = true } = formValues;
  return {
    theme: "book-a-call",
    signUp: signupRequired,
    customEmail: email,
    firstName,
    lastName,
    role,
  };
};

export const getDisplayedSourceOrigin = (src) => {
  switch (src) {
    case snackmagic.key:
      return snackmagic.title;
    case swagmagic.key:
      return swagmagic.title;
    case superiordishes.key:
      return superiordishes.title;
    case teambuilds.key:
      return teambuilds.title;
    default:
      return stadium.title;
  }
};
